module.exports = __webpack_public_path__ + "media/images/svg/logo-nsud-main-1188d16717cc82c673775298cb845a11.svg";